export default __webpack_public_path__ + "static/media/ssap.50ff871d.svg";